import React, { Component } from "react";
import Footer from "../../components/Footer/footer";
import NavbarPage from "../../components/Navbar/Navbar_Page";
import Section from "./section";

class PickYourTruck extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <React.Fragment>
        <NavbarPage />
        <Section />
        <Footer />
      </React.Fragment>
    );
  }
}

export default PickYourTruck;
